import React, { useState } from "react";
import { MainContainer } from "../Components/Elements";
import PagesNav from "../Components/PagesNav";
import { Offcanvas, Table } from "react-bootstrap";
import SearchInput from "../Components/SearchInput";
import AddInput from "../Components/AddInput";
import testImg from "../assets/images/testImg.png";
import editBtn from "../assets/icons/mediaIcons/edit.png";
import deleteBtn from "../assets/icons/mediaIcons/delete.png";
import UploadImage from "../Components/UploadImage";
import Shimmer from "../Components/Shimmer";
import MainDropdown from "../Components/MainDropdown";
import ArticleHooks from "../hooks/Media/ArticleHooks";
import MainInput from "../Components/MainInput";
const ProjectNews = () => {
  const {
    NavItems,
    setSearch,
    handleShow,
    show,
    teams,
    handleClose,
    handleImageChange,
    selectedTeamName,
    handleSelect,
  } = ArticleHooks();

  return (
    <>
      <MainContainer>
        <div className="d-flex gap-3 mb-3 align-items-center">
          <PagesNav links={NavItems} />
          <div className="d-flex gap-2">
            <SearchInput search={(e) => setSearch(e.target.value)} />
            <AddInput onClick={handleShow} />
          </div>
        </div>

        <div className="row align-items-center bg-light p-3 rounded-4">
          <div className="col-md-3">
            <img src={testImg} className="w-100" alt="testImg" />
          </div>
          <div className="col-md-9">
            <div>
              <h4>Title</h4>
              <h5 className="text-muted ">
                Short Description : Lorem Ipsum is simply dummy text of the
                printing and standard dummy text ever since the 1500s, Lorem
                Ipsum is simply dummy text of the printing and standard dummy
                text ever since the 1500s, Lorem Ipsum is simply dummy text of
                the printing and standard dummy text ever since the 1500s,
              </h5>
              <p>   
                <span className="fw-bold fs-5">Body : </span> 
                Contrary to popular belief, Lorem Ipsum is not simply
                random text. It has roots in a piece of classical Latin
                literature from 45 BC, making it over 2000 years old. Richard
                McClintock, a Latin professor at Hampden-Sydney College in
                Virginia, looked up one of the more obscure Latin words,
                consectetur, from a Lorem Ipsum passage, and going through the
                cites of the word in classical literature, discovered the
                undoubtable source. Lorem Ipsum comes from sections 1.10.32 and
                1.10.33 of "de Finibus Bonorum et Malorum" (The Extremes of Good
                and Evil) by Cicero, written in 45 BC. This book is a treatise
                on the theory of ethics, very popular during the Renaissance.
                The first line of Lorem Ipsum, "Lorem ipsum dolor sit amet..",
                comes from a line in section 1.10.32.
              </p>
            </div>
            <div className="text-end">
                <img className="cursor-pointer" src={editBtn} alt="editBtn" />
                <img className="cursor-pointer" src={deleteBtn} alt="deleteBtn" />
            </div>
          </div>
        </div>
        {Array.from({ length: 1 }, (_, index) => (
            <div key={index} className="row py-4 ">
            <Shimmer style={{ height: "340px", borderRadius: "20px"  , width:"100%"}} />
            </div>
          ))}
      </MainContainer>

      <Offcanvas show={show} onHide={handleClose} placement="end">
        <Offcanvas.Header className="pt-5" closeButton>
          <Offcanvas.Title>Add New Article</Offcanvas.Title>
        </Offcanvas.Header>
        <Offcanvas.Body className="d-flex flex-column justify-content-between">
          <div>
            <div className="d-flex">
            <MainInput label={"Title*"} placeholder={"Enter Name....."} langDir={"en"} required={true} type={"text"}/>
            <MainInput label={"*العنوان"} placeholder={"....ادخل الاسم"} langDir={"ar"} required={true} type={"text"} dir="rtl"/>
            </div>
            <UploadImage onChange={handleImageChange} />
            <div className="d-flex">
            <MainInput label={"Name*"} placeholder={"Enter Name....."} langDir={"en"} required={true} type={"text"}/>
            <MainInput label={"*وصف قصير"} placeholder={"....ادخل الاسم"} langDir={"ar"} required={true} type={"text"}  dir="rtl"/>
            </div>
            <div className="d-flex">
            <MainInput label={"Name*"} placeholder={"Enter Name....."} langDir={"en"} required={true} type={"text"}/>
            <MainInput label={"*اسم"} placeholder={"....ادخل الاسم"} langDir={"ar"} required={true} type={"text"} dir="rtl"/>
            </div>
          </div>

          <div className="d-flex justify-content-center align-items-center pb-3">
            <button className="btn bg-white text-main shadow-lg w-75 py-2 fw-bold">
              Submit
            </button>
          </div>
        </Offcanvas.Body>
      </Offcanvas>
    </>
  );
}

export default ProjectNews